export const TEST_ID = 'floatingResourceAddMenu';
